import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const InformationTooltip = () => {
  const [open, toggle] = useToggle(false)

  return (
    <Box alignItems="center">
      <Tooltip.ItemList
        attachment="top center"
        targetAttachment="bottom center"
        open={open}
        toggle={toggle}
      >
        <Box
          gap="s8"
          alignItems="center"
          cursor="pointer"
          flexDirection="row"
          justifyContent="spaceBetween"
        >
          <Icon.Small icon="question" encircled="grey800" />
        </Box>
        <Box gap="s16" alignItems="center">
          <Text.Header3>{i18n.t('shift_management.templates.settings_tooltip.title')}</Text.Header3>
          <Box alignItems="center" gap="s8">
            <Text.Normal>{i18n.t('shift_management.templates.settings_tooltip.hours')}</Text.Normal>
            <Text.Normal size="200">
              {i18n.t('shift_management.templates.settings_tooltip.hours_description')}
            </Text.Normal>
          </Box>
          <Box alignItems="center" gap="s8">
            <Text.Normal>{i18n.t('shift_management.templates.settings_tooltip.blank')}</Text.Normal>
            <Text.Normal size="200">
              {i18n.t('shift_management.templates.settings_tooltip.blank_description')}
            </Text.Normal>
          </Box>
          <Box alignItems="center" gap="s8">
            <Text.Normal>
              {i18n.t('shift_management.templates.settings_tooltip.rest_days')}
            </Text.Normal>
            <Text.Normal size="200">
              {i18n.t('shift_management.templates.settings_tooltip.rest_days_description')}
            </Text.Normal>
          </Box>
        </Box>
      </Tooltip.ItemList>
    </Box>
  )
}

export default observer(InformationTooltip)
